define('lib/Podio.UI.FormEmbedActions',['require','underscore','lib/Podio.Utils.Text','lib/fileuploader/multi','lib/Podio.UI.Embeds','lib/Podio.UI.Questions','lib/Podio.Event.UI','signals'],function(require) {

  var _ = require('underscore');
  var textUtils = require('lib/Podio.Utils.Text');
  var fileUploaderMulti = require('lib/fileuploader/multi');
  var embeds = require('lib/Podio.UI.Embeds');
  var questions = require('lib/Podio.UI.Questions');

  var podioEventUI = require('lib/Podio.Event.UI');
  var signalsLib = require('signals');

  var signals = {
    onFileUploadStarted : new signalsLib.Signal(),
    onFileUploadFinished : new signalsLib.Signal()
  };

  function onAttachButtonClick(elmTarget, e) {
    var elmContainer = elmTarget.parents('.embed-actions-wrapper');
    var elmActionBox = elmContainer.find('.action-box');
    var elmFileBox = elmActionBox.find('.files-box');

    elmActionBox.find('.arrow').css('left', elmTarget.position().left + 10);

    // Hide
    reset(elmActionBox);

    // Show
    elmActionBox.show();
    hideCloseButton(elmActionBox);

    if (elmTarget.hasClass('file')) { // **** File uploading is enabled ****

      elmFileBox.removeClass('hidden');
      elmActionBox.find('> .close-button').show();

      if(this.uploaderInstance) {
        // Already initialized, cleaning and returning
        this.uploaderInstance.clearAll();
        this.uploaderInstance.refresh();
        this.uploaderInstance.showDialog();
        return;
      }

      var elmHiddenInput = elmFileBox.parents('form').find('.files-hidden-input');
      if (!elmHiddenInput.length) {
        elmHiddenInput = elmContainer.find('.files-hidden-input');
      }

      this.uploaderInstance = fileUploaderMulti.render(elmFileBox, {
        skin : 'multi-file form-embed',
        elmHiddenInput : elmHiddenInput,
        showDialogOnInit : true,
        useFileFinder: true
      });


      this.uploaderInstance.signals.onUploadStarted.add(function() {
        signals.onFileUploadStarted.dispatch();
      });

      this.uploaderInstance.signals.onUploadFinished.add(function() {
        signals.onFileUploadFinished.dispatch();
      });

    } else if (elmTarget.hasClass('link')) {

      embeds.renderEmbedBox(elmActionBox);
      embeds.showAttachEmbed(elmActionBox, onEmbedFinished.curry(elmActionBox), onEmbedStarted.curry(elmActionBox));

    } else if (elmTarget.hasClass('question')) {

      questions.renderQuestionBox(elmActionBox);
      showCloseButton(elmActionBox);
      questions.showAttach(elmActionBox);

    }
  }

  function onEmbedFinished(elmActionBox) {
    var elmForm = elmActionBox.parents('form');
        elmForm.unbind('submit');

    showCloseButton(elmActionBox);
  }

  function onEmbedStarted(elmActionBox, elmInput) {
    var elmForm = elmActionBox.parents('form');
        elmForm.bind('submit', returnFalseHelper);

    if(elmInput) {
      elmInput.focus();
    }
  }

  function returnFalseHelper() {
    return false;
  }

  function onCloseButtonClick(elmTarget, e) {
    var elmActionBox = elmTarget.parents('.action-box');

    reset(elmActionBox);
  }

  function reset(elmActionBox) {
    var elmContainer = elmActionBox.parents('.embed-actions-wrapper');

    elmContainer.find('.files-hidden-input').val('');
    hideAll(elmActionBox);
  }

  function hideAll(elmActionBox) {
    var elmFileBox = elmActionBox.find('.files-box');

    // Hide
    elmActionBox.hide();
    elmFileBox.addClass('hidden');
    embeds.hideAttachEmbed(elmActionBox);
    embeds.hideEmbedPreview(elmActionBox);
    questions.hideAttach(elmActionBox);
  }

  function hideEmbedBox(elmTarget) {
    var elmContainer = elmTarget.parent();
    var elmActionBox = elmContainer.find('.action-box');

    elmActionBox.hide();
    embeds.hideAttachEmbed(elmActionBox);
    embeds.hideEmbedPreview(elmActionBox);
  }

  function showLinkBox(elmActionBox) {
    var elmFormActions = elmActionBox.parent();
    elmFormActions.find('.actions li.link').click();
  }

  function showFileBox(elmActionBox) {
    var elmFormActions = elmActionBox.parents('.form-embed-actions');
    elmFormActions.find('.actions li.file').click();
  }

  function hideCloseButton(elmActionBox) {
    elmActionBox.find('.close-button').hide();
  }

  function showCloseButton(elmActionBox) {
    elmActionBox.find('.close-button').show();
  }

  function handleAutoLinking(elmActionBox, elmInput) {
    var inputValue = elmInput.val();
    var urls = textUtils.extractUrlsWithIndices(inputValue);

    if(urls.length && !embeds.isShowingPreview(elmActionBox) && !elmActionBox.is(':visible')) {
      var url = urls[urls.length - 1];
      var selectionStart = elmInput.get(0).selectionStart;
      
      if (!_.isUndefined(selectionStart) && selectionStart >= url.indices[0] && selectionStart <= url.indices[1]) {      
        embeds.embedUrl(elmActionBox, url.url, onEmbedFinished.curry(elmActionBox), onEmbedStarted.curry(elmActionBox, elmInput));
        showLinkBox(elmActionBox);
      }
    }
  }

  // Event handlers
  podioEventUI.bind('click', '.form-embed-actions .attach li ', onAttachButtonClick);
  podioEventUI.bind('click', '.form-embed-actions .action-box .close-button ', onCloseButtonClick);

  // Stream specific, should be generalized
  podioEventUI.bind('click', '.streamcommentwrapper .action-box .close-button ', onCloseButtonClick);
  podioEventUI.bind('click', '.stream-composer .action-box .close-button ', onCloseButtonClick);

  return {
    signals : signals,
    hideEmbedBox: hideEmbedBox,
    showLinkBox: showLinkBox,
    showFileBox: showFileBox,
    showCloseButton: showCloseButton,
    hideCloseButton: hideCloseButton,
    handleAutoLinking: handleAutoLinking,
    hideAll: hideAll,
    reset: reset
  };

});

